const en = {
  nav: {
    home: "Home",
    exams: "Language Module",
    math: "Math Module",
    favorites: "Favorites",
    history: "History",
  },
  home: {
    hero_tag: "Welcome to EduLeaf",
    hero_title: "Grow Every Day,",
    hero_title_accent: "Learn Without Limits",
    hero_sub: "AI-powered learning tools for students from primary school to university. Friendly for students and parents alike.",
    cta_exam: "Start Language Module",
    cta_math: "Explore Math",
    modules_title: "Our Learning Modules",
    modules_sub: "Two powerful modules designed to help you study smarter and grow faster.",
    module1_title: "Language Module",
    module1_desc: "Generate AI-powered exams for Spanish, German, English. Upload your files or choose a difficulty level.",
    module1_tag: "AI-Powered",
    module2_title: "Math Module",
    module2_desc: "NZ curriculum–aligned math exercises from Year 1 to Year 13. Structured, clear, and scaffolded.",
    module2_tag: "NZ Curriculum",
    stats_exams: "Exams Generated",
    stats_subjects: "Subjects Supported",
    stats_students: "Students Helped",
    how_title: "How It Works",
    how_sub: "Three simple steps to smarter studying.",
    step1_title: "Choose a Subject",
    step1_desc: "Pick Spanish, German, Math, etc.",
    step2_title: "Generate Your Exam",
    step2_desc: "Upload files or let AI auto-generate by difficulty.",
    step3_title: "Study & Score",
    step3_desc: "Take the exam, check answers, and review favorites.",
  },
  exam: {
    title: "Language Module",
    choose_subject: "Choose a Subject",
    subject_sub: "Select a subject to begin. Upload materials or auto-generate by level.",
    subject_sub_2: "Upload materials or auto-generate by level.",
    spanish: "Spanish",
    german: "German",
    english: "English",
    generate_from_file: "Generate from File",
    auto_generate: "Auto Generate",
    upload_title: "Upload Your File",
    upload_desc: "Drag & drop or click to upload PDF, Word, or Image files. AI will scan the content and generate a customized exam.",
    upload_btn: "Choose File",
    upload_hint: "Supports PDF, DOCX, JPG, PNG – Max 20 MB",
    generate_btn: "Generate Exam",
    generating: "Generating exam…",
    levels: "Select Difficulty Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    dashboard_title: "My Dashboard",
    dashboard_sub: "Track your progress, review past exams, and visit your favorites.",
    history_title: "Exam History",
    history_empty: "No exams taken yet. Generate your first exam!",
    favorites_title: "My Favorites",
    favorites_empty: "No favorites saved yet. Star questions you want to revisit.",
    favorites_empty_hint: "Review your bookmarked questions anytime.",
    score_label: "Score",
    date_label: "Date",
    questions_label: "Questions",
    review_btn: "Review",
    take_exam_btn: "🔄 Reset & Retake",
  },
  exam_page: {
    multiple_choice: "Multiple Choice",
    fill_in: "Fill in the Blank",
    true_false: "True / False",
    translation: "Translation",
    verify_section: "Verify Section",
    submit_exam: "Submit Exam",
    favorite: "Favorite",
    unfavorite: "Unfavorited",
    answer_correct: "Correct!",
    answer_wrong: "Incorrect",
    score_result: "Your Score",
    total_score: "Total Score",
    out_of: "out of 100",
    listen_btn: "Play",
    question: "Question",
    your_answer: "Your Answer",
    model_answer: "Model Answer",
  },
  math: {
    title: "Math Module",
    subtitle: "Select Curriculum",
    desc: "Choose your educational system to start practising maths.",
    system_ncea: "NZ NCEA",
    system_ncea_desc: "New Zealand National Curriculum",
    system_cambridge: "Cambridge International",
    system_cambridge_desc: "A-Level / IGCSE Curriculum",
    system_ib: "International Baccalaureate",
    system_ib_desc: "IB Diploma Programme",
    primary: "Primary School",
    intermediate: "Intermediate",
    secondary: "Secondary School",
    year: "Year",
    coming_soon: "Coming Soon",
    coming_desc: "We're developing rich exercises for this level. Check back soon!",
    template_note: "This module is launching soon with full exercises.",
    tab_overview: "Roadmap & Goals",
    tab_topics: "Topics & Resources",
    tab_papers: "Past Papers",
  },
  common: {
    back: "Back",
    loading: "Loading…",
    error: "Something went wrong. Please try again.",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    close: "Close",
    search: "Search",
    language: "中文",
  },
};

export default en;
